// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 134) return "app-launcher/actiondesk.08b4379f12404120fc15.min.js";
	if (chunkId === 677) return "app-launcher/677.76dddf8070a04a37fec2.min.js";
	if (chunkId === 9) return "app-launcher/static.475ba020aed8787e1241.min.js";
	if (chunkId === 666) return "app-launcher/666.d8ccf319ef2732d4ee0c.min.js";
	if (chunkId === 807) return "app-launcher/dynamic-locale-jp-json.97bb6f47bed0a2ce8217.min.js";
	if (chunkId === 138) return "app-launcher/md-editor.bcf587fc76a51a170098.min.js";
	if (chunkId === 176) return "app-launcher/charts.715b6ddc29c563e742f2.min.js";
	if (chunkId === 522) return "app-launcher/maps.53807e7bc660c020a6a0.min.js";
	if (chunkId === 84) return "app-launcher/dendrogram.23f61f2b2001f82497a8.min.js";
	if (chunkId === 77) return "app-launcher/graph.d45e8287354cec9b0de2.min.js";
	if (chunkId === 108) return "app-launcher/sankey.fe17eb435a736bbd38c5.min.js";
	if (chunkId === 676) return "app-launcher/676.4faf92c81a5c312db36f.min.js";
	if (chunkId === 812) return "app-launcher/812.9ee9b9e722f78aaba89b.min.js";
	if (chunkId === 665) return "app-launcher/665.1a3da806ac4de00dca75.min.js";
	if (chunkId === 955) return "app-launcher/955.7a353700cdaf82b174ba.min.js";
	if (chunkId === 986) return "app-launcher/986.68fda9173d32a019e905.min.js";
	if (chunkId === 787) return "app-launcher/787.3e708e809b98d16d3883.min.js";
	// return url for filenames based on template
	return undefined;
};